module.exports = __webpack_public_path__ + "static/img/female-bg-en.c8a8afab.png";